export default {"src":"/_next/static/media/bg.f0402cb3.svg","height":456,"width":1440,"blurWidth":0,"blurHeight":0};